import { CREATE_JOB } from "@/store/actions";
import { TEAMMATES } from "./teammates";

export const SEARCH_LEVEL = {
  SUPERFICIAL: "superficial",
  AVERAGE: "average",
  DEEP: "deep",
};

export const SEARCH_ENGINES = {
  GOOGLE: "google",
  YOUTUBE: "youtube",
};

export const TASKS = {
  // Analysis
  ANALYSIS_COMPETITOR: "analysisCompetitor",
  ANALYSIS_MARKET: "analysisMarket",

  // Brainstorm
  BRAINSTORM_BLOG_POSTS: "brainstormBlogPosts",
  BRAINSTORM_FACEBOOK_POSTS: "brainstormFacebookPosts",
  BRAINSTORM_FACEBOOK_ADS: "brainstormFacebookAds",

  // Strategize
  STRATEGY_AUDIENCE: "strategyAudience",

  // Scrape
  VISIT_WEBSITE: "visitWebsite",
  VISIT_WEBSITE_PAGE: "visitWebsitePage",

  // Research
  CREATE_MINDMAP: "createMindmap",

  // Search
  SEARCH_YOUTUBE: "searchYouTube",
  SEARCH_GOOGLE: "searchGoogle",
  SEARCH_GOOGLE_MAPS: "searchGoogleMaps",
  SEARCH_GOOGLE_TRENDS: "searchGoogleTrends",
  SEARCH_GOOGLE_ADS: "searchGoogleAds",
  SEARCH_FACEBOOK_ADS: "searchFacebookAds",
  SEARCH_APPLE_STORE: "searchAppleStore",
  SEARCH_TWITTER: "searchTwitter",
  SEARCH_AMAZON: "searchAmazon",
  SEARCH_G2: "searchG2",

  // Outline
  OUTLINE_BLOG_POST: "outlineBlogPost",

  // Write
  WRITE_SALEPAGE: "writeSalepage",
  WRITE_BLOG_POST: "writeBlogPost",
  WRITE_BLOG_POST_SEO: "writeBlogPostSEO",
  WRITE_BLOG_POST_SEO_LONG: "writeBlogPostSEOLong",
  WRITE_BLOG_POST_SEO_DESCRIPTION: "writeBlogPostSEODescription",
  WRITE_FACEBOOK_POST: "writeFacebookPost",
  WRITE_FACEBOOK_AD: "writeFacebookAd",
  WRITE_INSTAGRAM_POST: "writeInstagramPost",
  WRITE_TWITTER_POST: "writeTwitterPost",
  WRITE_TWITTER_THREAD: "writeTwitterThread",
  WRITE_TWITTER_AD: "writeTwitterAd",
  WRITE_LINKEDIN_POST: "writeLinkedinPost",
  WRITE_LINKEDIN_AD: "writeLinkedinAd",
  WRITE_GOOGLE_AD: "writeGoogleAd",
  WRITE_YOUTUBE_POST: "writeYoutubePost",
  WRITE_YOUTUBE_INFO: "writeYoutubeInfo",

  // Visual
  CREATE_LOGO: "createLogo",
  DRAW_BLOG_POST_COVER: "createBlogPostCover",

  // Transcribe
  TRANSCRIBE_MEDIA: "transcribeMedia",
  TRANSCRIBE_YOUTUBE: "transcribeYoutube",

  // Summarize
  SUMMARIZE_TEXT: "summarizeText",
  SUMMARIZE_PDF: "summarizePdf",

  // Translate
  TRANSLATE_TEXT: "translateText",

  // Check
  DUPLICATE_TEXT: "duplicateText",

  // Support
  RETRIEVAL_QA: "retrievalQA",

  // Talk
  TALK: "talk",

  // Suggestions
  SUGGEST_BLOG_POST_COVER: "suggestBlogPostCover",
  SUGGEST_BLOG_POST_KEYWORDS: "suggestBlogPostKeywords",
};

export const TOOLS = {
  RUN_ANALYSIS: "run-analysis",
  RUN_OUTLINE: "run-outline",
  RUN_SUGGEST: "run-suggest",
  RUN_IMAGE: "run-image",
  RUN_WRITE: "run-write",
  RUN_WRITE_LONG: "run-write-long",
  RUN_SEARCH: "run-search",
  SEARCH_WEBSITE: "search-website",
  FILE_RETRIEVAL: "file-retrieval",
  FILE_TRANSCRIPTION: "file-transcription",
  YOUTUBE_CHANNEL: "youtube-channel",
  YOUTUBE_TRANSCRIPTION: "youtube-transcription",
  WRITE_BLOG_POST: "write-blog-post",
  CREATE_DOCUMENT: "create-document",
  QA_RETRIEVAL: "qa-retrieval",
  TEXT_SUMMARY: "text-summary",
  TEXT_CONCAT: "text-concat",
  TASK_CREATOR: "task-creator",
};

export const ANALYSIS_IDS = {
  FOUR_P: "fourP",
  SWOT: "swot",
  SEARCH_GOOGLE: "searchGoogle",
  SUMMARY: "summary",
};

export const OUTLINE_IDS = {
  MINDMAP_DRAFT: "mindmapDraft",
  BLOG_POST: "blogPost",
};

export const WRITING_IDS = {
  SALEPAGE: "salepage",
  BLOG_POST: "blogPost",
  BLOG_POST_SEO: "blogPostSEO",
  BLOG_POST_META_TITLE: "blogPostMetaTitle",
  BLOG_POST_META_PERMALINK: "blogPostMetaPermalink",
  BLOG_POST_META_DESCRIPTION: "blogPostMetaDescription",
  FACEBOOK_POST: "facebookPost",
  FACEBOOK_AD: "facebookAd",
  INSTAGRAM_POST: "instagramPost",
  TWITTER_POST: "twitterPost",
  TWITTER_THREAD: "twitterThread",
  TWITTER_AD: "twitterAd",
  LINKEDIN_POST: "linkedinPost",
  LINKEDIN_AD: "linkedinAd",
  GOOGLE_AD: "googleAd",
  YOUTUBE_POST: "youtubePost",
  YOUTUBE_INFO: "youtubeInfo",
};

export const SUGGESTIONS_IDS = {
  SUGGEST_BLOG_POST_COVER: "suggestBlogPostCover",
  SUGGEST_BLOG_POST_KEYWORDS: "suggestBlogPostKeywords",
};

export const TASKS_OPTIONS_COMMAND = [
  // Diverse
  { id: TASKS.TALK, name: "Talk", description: "Have a conversation with me", category: "Diverse", condition: () => true },
  {
    id: TASKS.SUMMARIZE_TEXT,
    name: "Summarize",
    description: "Summarize a text and get the key points.",
    icon: "",
    category: "Diverse",
    // creditsEstimation: "24 credits per minute for an audio and 36 credits per minute for a video",
    condition: (isPublic) => !isPublic,
  },
  {
    id: TASKS.TRANSCRIBE_MEDIA,
    name: "Transcribe",
    description: "Create a transcription of an audio or a video.",
    icon: "",
    category: "Diverse",
    creditsEstimation: "24 credits per minute for an audio and 36 credits per minute for a video",
    condition: (isPublic) => !isPublic,
  },
  {
    id: TASKS.TRANSLATE_TEXT,
    name: "Translate",
    description: "Translate text from one language to another.",
    category: "Diverse",
    condition: (isPublic) => !isPublic,
  },
  // {
  //   id: TASKS.TRANSCRIBE_YOUTUBE,
  //   name: "Transcribe YouTube",
  //   description: "Create a transcription of a YouTube video.",
  //   icon: "",
  //   category: "Diverse",
  //   // creditsEstimation: "24 credits per minute for an audio and 36 credits per minute for a video",
  //   condition: (isPublic) => !isPublic,
  // },
  /* {
    id: TASKS.DUPLICATE_TEXT,
    name: "Check for Duplicate Text",
    description: "Check text for potential duplication or plagiarism.",
    category: "Diverse",
    condition: (isPublic) => !isPublic,
  }, */

  // Analysis
  {
    id: TASKS.ANALYSIS_COMPETITOR,
    name: "Competitor Analysis",
    description: "Insert the URL of a competitor to make a deep analysis of their website and overall marketing strategy.",
    icon: "",
    badges: [{ variant: "primary", text: "flow" }],
    category: "Analysis",
    creditsEstimation: "About 1.000 credits",
    condition: (isPublic) => !isPublic,
  },
  /*  {
    id: TASKS.ANALYSIS_MARKET,
    name: "Market Analysis",
    description: "Analyze the market trends and data",
    category: "Analysis",
    condition: (isPublic) => !isPublic,
  }, */

  // Brainstorm
  /*  {
    id: TASKS.BRAINSTORM_BLOG_POSTS,
    name: "Brainstorm Blog Post Ideas",
    description: "Generate ideas for blog posts",
    category: "Brainstorm",
    condition: (isPublic) => !isPublic,
  }, */
  /* {
    id: TASKS.BRAINSTORM_FACEBOOK_POSTS,
    name: "Brainstorm Facebook Post Ideas",
    description: "Generate ideas for Facebook posts",
    category: "Brainstorm",
    condition: (isPublic) => !isPublic,
  }, */
  /* {
    id: TASKS.BRAINSTORM_FACEBOOK_ADS,
    name: "Brainstorm Facebook Ad Ideas",
    description: "Generate ideas for Facebook ads",
    category: "Brainstorm",
    condition: (isPublic) => !isPublic,
  }, */

  /*  {
    id: TASKS.CREATE_MINDMAP,
    name: "Create Mindmap",
    description: "",
    category: "Research",
    condition: (isPublic) => !isPublic,
  }, */
  // Stragize

  // Scrape

  // Search
  /* {
    id: TASKS.SEARCH_GOOGLE,
    name: "Search Google",
    description: "Perform a Google search to find informations on a specific topic",
    category: "Search",
    condition: (isPublic) => !isPublic,
  }, */
  /* {
    id: TASKS.SEARCH_YOUTUBE,
    name: "Search YouTube",
    description: "Look up videos on YouTube",
    category: "Search",
    condition: (isPublic) => !isPublic,
  }, */

  // Outline
  {
    id: TASKS.OUTLINE_BLOG_POST,
    name: "Outline a blog post",
    description: "Prepare a coherent outline for a long blog post on a specific subject.",
    category: "Outline",
    // creditsEstimation: "About 300 credits for 800 words",
    condition: (isPublic) => !isPublic,
  },
  // Write
  /* {
    id: TASKS.WRITE_SALEPAGE,
    name: "Write a sale page",
    description: "Develop a comprehensive sales page tailored for a designated product.",
    category: "Write",
    condition: (isPublic) => !isPublic,
  }, */
  /* {
    id: TASKS.WRITE_FACEBOOK_POST,
    name: "Write a facebook post",
    description: "Design a captivating Facebook advertisement targeting specific product promotion.",
    category: "Write",
    condition: (isPublic) => !isPublic,
  }, */

  {
    id: TASKS.WRITE_BLOG_POST,
    name: "Write a blog post",
    description: "Craft an engaging and informative content tailored for your blog, focusing on relevant topics.",
    category: "Write",
    creditsEstimation: "About 300 credits for 800 words",
    condition: (isPublic) => !isPublic,
  },
  {
    id: TASKS.WRITE_BLOG_POST_SEO,
    name: "Write a blog post - SEO optimized",
    description: "Write a short blog post (around 800 words) focusing on specific keywords.",
    category: "Write",
    creditsEstimation: "About 300 credits for 800 words",
    condition: (isPublic) => !isPublic,
  },
  {
    id: TASKS.WRITE_BLOG_POST_SEO_LONG,
    name: "Write a pilar blog post - SEO optimized",
    description: "Write a long blog post (around 4000 words) focusing on specific keywords.",
    category: "Write",
    // creditsEstimation: "About 300 credits for 800 words",
    condition: (isPublic) => !isPublic,
  },

  // Visual
  {
    id: TASKS.DRAW_BLOG_POST_COVER,
    name: "Blog Post Cover",
    description: "Create a a blog post cover.",
    icon: "",
    category: "Visual",
    creditsEstimation: "160 credits for a squared image and 320 for an horizontal or vertical image",
    // creditsEstimation: "24 credits per minute for an audio and 36 credits per minute for a video",
    condition: (isPublic) => !isPublic,
  },

  // Support
  // {
  //   id: TASKS.RETRIEVAL_QA,
  //   name: "Answer A Question",
  //   description: "Give a precise and useful response to a query using one of your provided document.",
  //   icon: "",
  //   category: "Support",
  //   // creditsEstimation: "24 credits per minute for an audio and 36 credits per minute for a video",
  //   condition: (isPublic) => !isPublic,
  // },
];

// TODO: Merge it inside DEFAULT_REPLY
export const DEFAULT_FIRST_MESSAGE = {
  [TASKS.ANALYSIS_COMPETITOR]: "All right, let's look at your competitor!",
  [TASKS.SEARCH_GOOGLE]: "All right, let's do a Google search.",
  [TASKS.OUTLINE_BLOG_POST]: "All right, let's create an outline. Which topic do you want to explore?",
  [TASKS.WRITE_SALEPAGE]: "All right, let's crush that. First of all, I need to know which product we are going to work on.",
  [TASKS.WRITE_BLOG_POST]: "All right, let's write a new blog post!",
  [TASKS.WRITE_BLOG_POST_SEO]: "All right, let's write a new blog post!",
  [TASKS.WRITE_BLOG_POST_SEO_LONG]: "All right, let's write a new core blog post!",
  [TASKS.WRITE_FACEBOOK_POST]: "All right, let's write a new facebook post!",
  [TASKS.DRAW_BLOG_POST_COVER]: "All right, let's design a blog post cover!",
  [TASKS.RETRIEVAL_QA]: "All right, what's the question?",
  [TASKS.TRANSCRIBE_MEDIA]: "All right, let's do some transcription work! Drop your file and I'll take care of it.",
  [TASKS.TRANSCRIBE_YOUTUBE]: "What's the URL of the YouTube video?.",
  [TASKS.SUMMARIZE_TEXT]: "All right, let's do some summarization! Copy paste your text and I'll take care of it.",
  [TASKS.TALK]: "All right, what can I do for you?",
};

//
// IMPORTANT:
// Everytime a new function is being added, add it also in the backend
//

export const DEFAULT_REPLY = {
  [TASKS.ANALYSIS_COMPETITOR]: {
    format: "form",
    headline: "Which Competitor Should I Look At?",
    firstMessage: "Check this one", // Only the prefix will be translated
    firstMessageSuffix: "<a href='$url' target='_blank'><span class='url-analysis'>$url</a>",
    stateMachine: {
      id: "analysis-competitor",
      initialStep: "step-url",
      context: {
        currentStep: "step-url",
        formData: {
          url: "",
        },
      },
      steps: {
        "step-url": {
          NEXT: {},
          BACK: {},
          options: {
            fields: [
              {
                componentName: "Url",
                name: "url",
                validators: ["required", "url"],
                label: "",
                attributes: {
                  placeholder: "Insert the URL of your competitor...",
                },
              },
            ],
          },
        },
      },
    },
    storeDispatch: `projectsTasksTools/${CREATE_JOB}`,
    defaultData: {
      tasksList: [
        {
          id: "webscrapping",
          status: false,
          text: "Visiting competitor website",
          handler: TOOLS.SEARCH_WEBSITE,
        },
        {
          id: "fourPAnalysis",
          status: false,
          text: "Running a 4P Analysis",
          handler: TOOLS.RUN_ANALYSIS,
          args: { analysisId: ANALYSIS_IDS.FOUR_P, resultKey: "fourpAnalysis" },
        },
        {
          id: "swotAnalysis",
          status: false,
          text: "Running a SWOT Analysis",
          handler: TOOLS.RUN_ANALYSIS,
          args: { analysisId: ANALYSIS_IDS.SWOT, resultKey: "swotAnalysis" },
        },
        {
          id: "summary",
          status: false,
          text: "Writing down the report",
          handler: TOOLS.RUN_ANALYSIS,
          args: { analysisId: ANALYSIS_IDS.SUMMARY, resultKey: "content" },
        },
        {
          id: "document",
          status: false,
          text: "Creating the final report",
          handler: TOOLS.CREATE_DOCUMENT,
          args: { name: "webscrappingTitle", content: "summaryContent" },
        },
      ],
      message: {
        type: "document",
        content: `Done! The competitor analysis of <a href="$HOST/$projectId/documents/$documentDocumentId" class="document-link">
        <span class='document-name'>competitor-analysis-$url <em>(ID: $documentDocumentId)</em></span></a> is ready.`,
      },
    },
  },
  [TASKS.SEARCH_GOOGLE]: {
    format: "form",
    headline: "What are we looking for?",
    firstMessage: "$searchLevel $query",
    stateMachine: {
      id: "search-google",
      initialStep: "step-url",
      context: {
        currentStep: "step-url",
        formData: {
          searchLevel: SEARCH_LEVEL.SUPERFICIAL,
          query: "",
        },
      },
      steps: {
        "step-url": {
          NEXT: {},
          BACK: {},
          options: {
            fields: [
              {
                componentName: "Select",
                name: "searchLevel",
                validators: ["required"],
                label: "Search Level",
                attributes: {
                  options: [
                    { value: SEARCH_LEVEL.SUPERFICIAL, text: "Superficial" },
                    { value: SEARCH_LEVEL.AVERAGE, text: "Average" },
                    { value: SEARCH_LEVEL.DEEP, text: "Deep" },
                  ],
                },
              },
              {
                componentName: "Input",
                name: "query",
                validators: ["required"],
                label: "Keyword",
                attributes: {
                  placeholder: "What should we be searching for?",
                },
              },
            ],
          },
        },
      },
    },
    storeDispatch: `projectsTasksTools/${CREATE_JOB}`,
    defaultData: {
      tasksList: [
        {
          id: "search",
          status: false,
          text: "Searching Google",
          handler: TOOLS.RUN_RESEARCH,
          args: { engine: SEARCH_ENGINES.GOOGLE },
        },
        /* {
          id: "analysis",
          status: false,
          text: "Summarize Google Search",
          handler: TOOLS.RUN_ANALYSIS,
          args: { analysisId: ANALYSIS_IDS.SEARCH_GOOGLE, resultKey: "content" },
        }, */
      ],
      message: {
        type: "document",
        content: `Done! The search is done`,
      },
    },
  },
  [TASKS.CREATE_MINDMAP]: {
    format: "form",
    headline: "What are we looking for?",
    firstMessage: "$searchLevel $centralIdea",
    stateMachine: {
      id: "create-mindmap",
      initialStep: "step-url",
      context: {
        currentStep: "step-url",
        formData: {
          searchLevel: SEARCH_LEVEL.SUPERFICIAL,
          youtubeChannelName: "",
          centralIdea: "",
        },
      },
      steps: {
        "step-url": {
          NEXT: {},
          BACK: {},
          options: {
            fields: [
              {
                componentName: "Select",
                name: "searchLevel",
                validators: ["required"],
                label: "Search Level",
                attributes: {
                  options: [
                    { value: SEARCH_LEVEL.SUPERFICIAL, text: "Superficial" },
                    { value: SEARCH_LEVEL.AVERAGE, text: "Average" },
                    { value: SEARCH_LEVEL.DEEP, text: "Deep" },
                  ],
                },
              },
              {
                componentName: "Input",
                name: "youtubeChannelName",
                validators: ["required"],
                label: "youtubeChannelName",
                attributes: {
                  placeholder: "YouTube Channel Id",
                },
              },
              {
                componentName: "Message",
                name: "centralIdea",
                validators: ["required"],
                label: "Central Idea",
                attributes: {
                  placeholder: "What should we be searching for?",
                },
              },
            ],
          },
        },
      },
    },
    storeDispatch: `projectsTasksTools/${CREATE_JOB}`,
    defaultData: {
      tasksList: [
        {
          id: "youtube",
          status: false,
          text: "Fetch YouTube videos",
          handler: TOOLS.YOUTUBE_CHANNEL,
          // args: { outlineId: OUTLINE_IDS.MINDMAP_DRAFT },
        },
        {
          status: false,
          id: "creator",
          text: "Create new tasks",
          handler: TOOLS.TASK_CREATOR,
          args: {
            newTasksVariable: { key: "youtubeVideosList", handler: TOOLS.YOUTUBE_TRANSCRIPTION, args: {} },
          },
        },
        /*   {
          id: "outline",
          status: false,
          text: "Create outline",
          handler: TOOLS.CREATE_MINDMAP,
          args: { outlineId: OUTLINE_IDS.MINDMAP_DRAFT },
        }, */
        /*  {
          id: "search",
          status: false,
          text: "Searching Google",
          handler: TOOLS.RUN_RESEARCH,
          args: { engine: SEARCH_ENGINES.GOOGLE },
        }, */
        /* {
          id: "analysis",
          status: false,
          text: "Summarize Google Search",
          handler: TOOLS.RUN_ANALYSIS,
          args: { analysisId: ANALYSIS_IDS.SEARCH_GOOGLE, resultKey: "content" },
        }, */
      ],
      message: {
        type: "document",
        content: `Done!\n$youtubeContent`,
      },
    },
  },
  [TASKS.OUTLINE_BLOG_POST]: {
    format: "form",
    headline: "Tell Me More",
    firstMessage: `$description`,
    stateMachine: {
      id: "outline-blog-post",
      initialStep: "step-post",
      context: {
        currentStep: "step-post",
        formData: {
          description: "",
          references: [],
        },
      },
      steps: {
        "step-post": {
          NEXT: {},
          BACK: {},
          options: {
            fields: [
              {
                componentName: "Message",
                name: "description",
                validators: ["required"],
                label: "Description",
                attributes: {
                  placeholder: "Explain which subject you'd like to explore...",
                },
              },
            ],
          },
        },
      },
    },
    storeDispatch: `projectsTasksTools/${CREATE_JOB}`,
    defaultData: {
      tasksList: [
        {
          id: "outline",
          status: false,
          text: "Writing outline",
          handler: TOOLS.RUN_OUTLINE,
          args: { outlineId: OUTLINE_IDS.BLOG_POST },
        },
        {
          id: "document",
          status: false,
          text: "Creating document",
          handler: TOOLS.CREATE_DOCUMENT,
          args: { name: "outlineName", content: "outlineContent" },
        },
      ],
      message: {
        type: "document",
        content: `Done! The blog post outline <a href="$HOST/$projectId/documents/$documentDocumentId" class="document-link">
<span class='document-name'>$outlineName <em>(ID: $documentDocumentId)</em></span></a> is ready.`,
      },
    },
  },
  [TASKS.WRITE_BLOG_POST]: {
    format: "form",
    headline: "Tell Me More",
    firstMessage: `Write a blog post and follow those requirements:`,
    firstMessageSuffix: `Structure: $structureId
Description: $description
`,
    stateMachine: {
      id: "write-blog-post",
      initialStep: "step-post",
      context: {
        currentStep: "step-post",
        formData: {
          teammateId: null,
          structureId: "how-to",
          description: "",
          references: [],
        },
      },
      steps: {
        "step-post": {
          NEXT: {},
          BACK: {},
          options: {
            fields: [
              {
                componentName: "Select",
                name: "teammateId",
                validators: [],
                label: "AI Teammate",
                attributes: {
                  options: [],
                },
              },
              {
                componentName: "Select",
                name: "structureId",
                validators: ["required"],
                label: "Structure",
                attributes: {
                  options: [
                    { value: "how-to", text: "How-to Guide" },
                    { value: "listicle", text: "Listicle" },
                    { value: "news-update", text: "News Update" },
                    { value: "opinion", text: "Opinion Piece" },
                    { value: "case-study", text: "Case Study" },
                    { value: "tutorial", text: "Tutorial" },
                    { value: "comparison", text: "Comparison Post" },
                    { value: "FAQ", text: "FAQ" },
                    { value: "checklist", text: "Checklist" },
                    { value: "other", text: "Other" },
                  ],
                },
              },
              {
                componentName: "Message",
                name: "description",
                validators: ["required"],
                label: "Description",
                attributes: {
                  placeholder: "Insert the description of your blog post...",
                },
              },
            ],
          },
        },
      },
    },
    storeDispatch: `projectsTasksTools/${CREATE_JOB}`,
    defaultData: {
      tasksList: [
        {
          id: "post",
          status: false,
          text: "Writing blog post",
          handler: TOOLS.RUN_WRITE,
          args: { writingId: WRITING_IDS.BLOG_POST },
        },
        {
          id: "document",
          status: false,
          text: "Creating document",
          handler: TOOLS.CREATE_DOCUMENT,
          args: { name: "postName", content: "postContent" },
        },
      ],
      message: {
        type: "document",
        content: `Done! The blog post <a href="$HOST/$projectId/documents/$documentDocumentId" class="document-link">
<span class='document-name'>$postName <em>(ID: $documentDocumentId)</em></span></a> is ready.`,
      },
    },
  },
  [TASKS.WRITE_BLOG_POST_SEO]: {
    format: "form",
    headline: "Tell Me More",
    firstMessage: `Write a blog post and follow those requirements:`,
    firstMessageSuffix: `Structure: $structureId
Description: $description

$keywords
`,
    stateMachine: {
      id: "write-blog-post-seo",
      initialStep: "step-post",
      context: {
        currentStep: "step-post",
        formData: {
          teammateId: null,
          structureId: "how-to",
          name: "",
          description: "",
          keywords: "",
          references: [],
        },
      },
      steps: {
        "step-post": {
          NEXT: {},
          BACK: {},
          options: {
            fields: [
              {
                componentName: "Select",
                name: "teammateId",
                validators: [],
                label: "AI Teammate",
                attributes: {
                  options: [],
                },
              },
              {
                componentName: "Select",
                name: "structureId",
                validators: ["required"],
                label: "Structure",
                attributes: {
                  options: [
                    { value: "how-to", text: "How-to Guide" },
                    { value: "listicle", text: "Listicle" },
                    { value: "news-update", text: "News Update" },
                    { value: "opinion", text: "Opinion Piece" },
                    { value: "case-study", text: "Case Study" },
                    { value: "tutorial", text: "Tutorial" },
                    { value: "comparison", text: "Comparison Post" },
                    { value: "FAQ", text: "FAQ" },
                    { value: "checklist", text: "Checklist" },
                    { value: "other", text: "Other" },
                  ],
                },
              },
              /* {
                componentName: "Input",
                name: "name",
                validators: [],
                label: "Name",
                attributes: {
                  placeholder: "Insert the name of your blog post (optional)...",
                },
              }, */
              {
                componentName: "Message",
                name: "description",
                validators: ["required"],
                label: "Description",
                attributes: {
                  placeholder: "Insert the description of your blog post...",
                },
              },
              {
                componentName: "SeoKeywords",
                name: "keywords",
                validators: ["required"],
                label: "Keywords",
                attributes: {
                  placeholder: "Insert the keywords you'd like to optimize for (separate each keyword with a comma)...",
                },
              },
            ],
          },
        },
      },
    },
    storeDispatch: `projectsTasksTools/${CREATE_JOB}`,
    defaultData: {
      tasksList: [
        {
          status: false,
          id: "post",
          text: "Writing blog post",
          handler: TOOLS.RUN_WRITE,
          args: { writingId: WRITING_IDS.BLOG_POST_SEO },
        },
        {
          status: false,
          id: "metaTitle",
          text: "Writing meta title",
          handler: TOOLS.RUN_WRITE,
          args: { writingId: WRITING_IDS.BLOG_POST_META_TITLE },
        },
        {
          status: false,
          id: "metaPermalink",
          text: "Writing meta permalink",
          handler: TOOLS.RUN_WRITE,
          args: { writingId: WRITING_IDS.BLOG_POST_META_PERMALINK },
        },
        {
          status: false,
          id: "metaDescription",
          text: "Writing meta description",
          handler: TOOLS.RUN_WRITE,
          args: { writingId: WRITING_IDS.BLOG_POST_META_DESCRIPTION },
        },
        {
          status: false,
          id: "concat",
          text: "Merge post and description",
          handler: TOOLS.TEXT_CONCAT,
          args: {
            variables: [
              { key: "metaTitleContent", prefix: "<h1>Meta Title</h1>" },
              { key: "metaPermalinkContent", prefix: "<h1>Meta Permalink</h1>" },
              { key: "metaDescriptionContent", prefix: "<h1>Meta Description</h1>" },
              { key: "keywords", prefix: "<h1>Meta Keywords</h1>" },
              { key: "postContent", prefix: "<h1>Content</h1>" },
            ],
          },
        },
        {
          status: false,
          id: "document",
          text: "Creating document",
          handler: TOOLS.CREATE_DOCUMENT,
          args: { name: "postName", content: "concatContent" },
        },
      ],
      message: {
        type: "document",
        content: `Done! The blog post <a href="$HOST/$projectId/documents/$documentDocumentId" class="document-link">
<span class='document-name'>$postName <em>(ID: $documentDocumentId)</em></span></a> is ready.`,
      },
    },
  },
  [TASKS.WRITE_BLOG_POST_SEO_LONG]: {
    format: "form",
    headline: "Tell Me More",
    firstMessage: `Write a blog post and follow those requirements:`,
    firstMessageSuffix: `Structure: $structureId
Description: $description

$keywords
`,
    stateMachine: {
      id: "write-blog-post-seo-long",
      initialStep: "step-post",
      context: {
        currentStep: "step-post",
        formData: {
          teammateId: null,
          structureId: "how-to",
          name: "",
          description: "",
          references: [],
        },
      },
      steps: {
        "step-post": {
          NEXT: {},
          BACK: {},
          options: {
            fields: [
              {
                componentName: "Select",
                name: "teammateId",
                validators: [],
                label: "AI Teammate",
                attributes: {
                  options: [],
                },
              },
              {
                componentName: "Select",
                name: "structureId",
                validators: ["required"],
                label: "Structure",
                attributes: {
                  options: [
                    { value: "how-to", text: "How-to Guide" },
                    { value: "listicle", text: "Listicle" },
                    { value: "news-update", text: "News Update" },
                    { value: "opinion", text: "Opinion Piece" },
                    { value: "case-study", text: "Case Study" },
                    { value: "tutorial", text: "Tutorial" },
                    { value: "comparison", text: "Comparison Post" },
                    { value: "FAQ", text: "FAQ" },
                    { value: "checklist", text: "Checklist" },
                    { value: "other", text: "Other" },
                  ],
                },
              },
              /* {
                componentName: "Input",
                name: "name",
                validators: [],
                label: "Name",
                attributes: {
                  placeholder: "Insert the name of your blog post (optional)...",
                },
              }, */
              {
                componentName: "Message",
                name: "description",
                validators: ["required"],
                label: "Description",
                attributes: {
                  placeholder: "Insert the description of your blog post...",
                },
              },
              {
                componentName: "SeoKeywords",
                name: "keywords",
                validators: ["required"],
                label: "Keywords",
                attributes: {
                  placeholder: "Insert the keywords you'd like to optimize for (separate each keyword with a comma)...",
                },
              },
            ],
          },
        },
      },
    },
    storeDispatch: `projectsTasksTools/${CREATE_JOB}`,
    defaultData: {
      tasksList: [
        {
          status: false,
          id: "outline",
          text: "Preparing blog post outline",
          handler: TOOLS.RUN_OUTLINE,
          args: { outlineId: OUTLINE_IDS.BLOG_POST },
        },
        {
          status: false,
          id: "post",
          text: "Writing blog post",
          handler: TOOLS.RUN_WRITE_LONG,
          args: { writingId: WRITING_IDS.BLOG_POST_SEO, keyName: "outlineName", keyContent: "outlineContentJSON" },
        },
        {
          status: false,
          id: "metaTitle",
          text: "Writing meta title",
          handler: TOOLS.RUN_WRITE,
          args: { writingId: WRITING_IDS.BLOG_POST_META_TITLE },
        },
        {
          status: false,
          id: "metaPermalink",
          text: "Writing meta permalink",
          handler: TOOLS.RUN_WRITE,
          args: { writingId: WRITING_IDS.BLOG_POST_META_PERMALINK },
        },
        {
          status: false,
          id: "metaDescription",
          text: "Writing meta description",
          handler: TOOLS.RUN_WRITE,
          args: { writingId: WRITING_IDS.BLOG_POST_META_DESCRIPTION },
        },
        {
          status: false,
          id: "concat",
          text: "Merge post and description",
          handler: TOOLS.TEXT_CONCAT,
          args: {
            variables: [
              { key: "metaTitleContent", prefix: "<h1>Meta Title</h1>" },
              { key: "metaPermalinkContent", prefix: "<h1>Meta Permalink</h1>" },
              { key: "metaDescriptionContent", prefix: "<h1>Meta Description</h1>" },
              { key: "keywords", prefix: "<h1>Meta Keywords</h1>" },
              { key: "postContent", prefix: "<h1>Content</h1>" },
            ],
          },
        },
        {
          status: false,
          id: "document",
          text: "Creating document",
          handler: TOOLS.CREATE_DOCUMENT,
          args: { name: "postName", content: "concatContent" },
        },
      ],
      message: {
        type: "document",
        content: `Done! The blog post <a href="$HOST/$projectId/documents/$documentDocumentId" class="document-link">
<span class='document-name'>$postName <em>(ID: $documentDocumentId)</em></span></a> is ready.`,
      },
    },
  },
  [TASKS.DRAW_BLOG_POST_COVER]: {
    format: "form",
    headline: "Tell Me More",
    firstMessage: `Imagine an image and follow those requirements:\n
Size: $size\n
Description: $description`,
    stateMachine: {
      id: "blog-post-cover",
      initialStep: "step-post",
      context: {
        currentStep: "step-post",
        formData: {
          size: "1024x1024",
          teammateId: "",
          description: "",
        },
      },
      steps: {
        "step-post": {
          NEXT: {},
          BACK: {},
          options: {
            fields: [
              {
                componentName: "Select",
                name: "teammateId",
                validators: [],
                label: "AI Teammate",
                attributes: {
                  options: [],
                },
              },
              {
                componentName: "Select",
                name: "size",
                validators: ["required"],
                label: "Size",
                attributes: {
                  options: [
                    { value: "1024x1024", text: "Square" },
                    { value: "1024x1792", text: "Vertical" },
                    { value: "1792x1024", text: "Horizontal" },
                  ],
                },
              },
              {
                componentName: "Message",
                name: "description",
                validators: ["required"],
                label: "Description",
                attributes: {
                  placeholder: "Insert the description of your blog post cover...",
                },
              },
            ],
          },
        },
      },
    },
    storeDispatch: `projectsTasksTools/${CREATE_JOB}`,
    defaultData: {
      tasksList: [
        {
          status: false,
          id: "image",
          text: "Creating the image",
          handler: TOOLS.RUN_IMAGE,
          args: {},
        },
      ],
      message: {
        type: "document",
        content: `Done!`,
        contentSuffix: `$imageContent`,
      },
    },
  },
  [TASKS.RETRIEVAL_QA]: {
    format: "form",
    headline: "Tell Me More",
    firstMessage: `Answer the following question:\n
Question: $query
`,
    stateMachine: {
      id: "retrieval-qa",
      initialStep: "step-post",
      context: {
        currentStep: "step-post",
        formData: {
          teammateId: "",
          query: "",
        },
      },
      steps: {
        "step-post": {
          NEXT: {},
          BACK: {},
          options: {
            fields: [
              {
                componentName: "Select",
                name: "teammateId",
                validators: [],
                label: "AI Teammate",
                attributes: {
                  options: [],
                },
              },
              {
                componentName: "Message",
                name: "query",
                validators: ["required"],
                label: "Question",
                attributes: {
                  placeholder: "Insert the question...",
                },
              },
            ],
          },
        },
      },
    },
    storeDispatch: `projectsTasksTools/${CREATE_JOB}`,
    defaultData: {
      tasksList: [
        {
          status: false,
          id: "qa",
          text: "Searching through your documents and crafting the most appropriate answer...",
          handler: TOOLS.QA_RETRIEVAL,
          args: {},
        },
      ],
      message: {
        content: `$qaAnswer`,
      },
    },
  },
  [TASKS.TRANSCRIBE_MEDIA]: { format: "file", headline: "" },
  [TASKS.TRANSCRIBE_YOUTUBE]: {
    format: "form",
    headline: "Tell Me More",
    firstMessage: `Transcribe this video: $youtubeUrl
`,
    stateMachine: {
      id: "youtube",
      initialStep: "step-post",
      context: {
        currentStep: "step-post",
        formData: {
          youtubeUrl: "",
        },
      },
      steps: {
        "step-post": {
          NEXT: {},
          BACK: {},
          options: {
            fields: [
              {
                componentName: "Url",
                name: "youtubeUrl",
                validators: ["required"],
                label: "Youtube URL",
                attributes: {
                  placeholder: "Copy paste the youtube URL...",
                },
              },
            ],
          },
        },
      },
    },
    storeDispatch: `projectsTasksTools/${CREATE_JOB}`,
    defaultData: {
      tasksList: [
        {
          status: false,
          id: "transcript",
          text: "Transcription",
          handler: TOOLS.YOUTUBE_TRANSCRIPTION,
          args: {},
        },
      ],
      message: {
        content: `Youtube Video Transcription:
$transcriptContent`,
      },
    },
  },
  [TASKS.SUMMARIZE_TEXT]: {
    format: "form",
    headline: "Tell Me More",
    firstMessage: `Summarize and extract the key points of the following text:\n
Text: $text
`,
    stateMachine: {
      id: "summarize-text",
      initialStep: "step-post",
      context: {
        currentStep: "step-post",
        formData: {
          text: "",
        },
      },
      steps: {
        "step-post": {
          NEXT: {},
          BACK: {},
          options: {
            fields: [
              {
                componentName: "Message",
                name: "text",
                validators: ["required"],
                label: "Text",
                attributes: {
                  placeholder: "Copy paste the text...",
                },
              },
            ],
          },
        },
      },
    },
    storeDispatch: `projectsTasksTools/${CREATE_JOB}`,
    defaultData: {
      tasksList: [
        {
          status: false,
          id: "summary",
          text: "Reading and summarizing",
          handler: TOOLS.TEXT_SUMMARY,
          args: {},
        },
      ],
      message: {
        content: `$summaryContent`,
      },
    },
  },
  /* [TASKS.SUMMARIZE_PDF]: {
    format: "form",
    headline: "Tell Me More",
    firstMessage: `Summarize and extract the key points of the following PDF file.\n`,
    stateMachine: {
      id: "summarize-pdf",
      initialStep: "step-post",
      context: {
        currentStep: "step-post",
        formData: {
          text: "",
        },
      },
      steps: {
        "step-post": {
          NEXT: {},
          BACK: {},
          options: {
            fields: [
              {
                componentName: "Message",
                name: "text",
                validators: ["required"],
                label: "Text",
                attributes: {
                  placeholder: "Copy paste the text...",
                },
              },
            ],
          },
        },
      },
    },
    storeDispatch: `projectsTasksTools/${CREATE_JOB}`,
    defaultData: {
      tasksList: [
        {
          status: false,
          id: "summary",
          text: "Reading and summarizing",
          handler: TOOLS.TEXT_SUMMARY,
          args: {},
        },
      ],
      message: {
        content: `$summaryContent`,
      },
    },
  }, */
};

export const ACTION_BY_TEAMMATE = {
  [TASKS.WRITE_BLOG_POST]: TEAMMATES.COPYWRITER,
  [TASKS.WRITE_BLOG_POST_SEO]: TEAMMATES.COPYWRITER,
  [TASKS.WRITE_BLOG_POST_SEO_LONG]: TEAMMATES.COPYWRITER,
  [TASKS.WRITE_BLOG_POST_SEO_DESCRIPTION]: TEAMMATES.COPYWRITER,
  [TASKS.DRAW_BLOG_POST_COVER]: TEAMMATES.ILLUSTRATOR,
  [TASKS.RETRIEVAL_QA]: TEAMMATES.SUPPORT,
};

export const COUNTRIES_OPTIONS = [
  { value: "us", text: "United States" },
  { value: "fr", text: "France" },
];

export const INDUSTRIES_OPTIONS = [
  { value: "aerospace-and-defense", text: "Aerospace and Defense" },
  { value: "agriculture-and-food-production", text: "Agriculture and Food Production" },
  { value: "agriculture-and-rural-development", text: "Agriculture and Rural Development" },
  { value: "alternative-dispute-resolution", text: "Alternative Dispute Resolution" },
  { value: "animal-welfare", text: "Animal Welfare" },
  { value: "art-and-cultural-institutions", text: "Art and Cultural Institutions" },
  { value: "automotive", text: "Automotive" },
  { value: "aviation", text: "Aviation" },
  { value: "banking-and-finance", text: "Banking and Finance" },
  { value: "biotechnology-and-life-sciences", text: "Biotechnology and Life Sciences" },
  { value: "chemical", text: "Chemical" },
  { value: "climate-change-and-sustainability", text: "Climate Change and Sustainability" },
  { value: "commerce-and-industry", text: "Commerce and Industry" },
  { value: "communications-and-information-technology", text: "Communications and Information Technology" },
  { value: "consumer-affairs", text: "Consumer Affairs" },
  { value: "cultural-affairs", text: "Cultural Affairs" },
  { value: "data-protection-and-privacy", text: "Data Protection and Privacy" },
  { value: "defense-and-military", text: "Defense and Military" },
  { value: "defense-and-security", text: "Defense and Security" },
  { value: "disaster-management-and-relief", text: "Disaster Management and Relief" },
  { value: "education", text: "Education" },
  { value: "elder-care-and-retirement", text: "Elder Care and Retirement" },
  { value: "energy", text: "Energy" },
  { value: "energy-and-utilities", text: "Energy and Utilities" },
  { value: "environment-and-natural-resources", text: "Environment and Natural Resources" },
  { value: "environmental", text: "Environmental" },
  { value: "event-management", text: "Event Management" },
  { value: "fashion-and-apparel", text: "Fashion and Apparel" },
  { value: "finance-and-treasury", text: "Finance and Treasury" },
  { value: "fisheries-and-oceans", text: "Fisheries and Oceans" },
  { value: "foreign-affairs", text: "Foreign Affairs" },
  { value: "forestry-and-paper", text: "Forestry and Paper" },
  { value: "funeral-and-cemetery-services", text: "Funeral and Cemetery Services" },
  { value: "gaming-and-gambling", text: "Gaming and Gambling" },
  { value: "government-and-public-sector", text: "Government and Public Sector" },
  { value: "health-and-human-services", text: "Health and Human Services" },
  { value: "healthcare", text: "Healthcare" },
  { value: "hospitality-and-leisure", text: "Hospitality and Leisure" },
  { value: "housing-and-urban-development", text: "Housing and Urban Development" },
  { value: "human-rights", text: "Human Rights" },
  { value: "immigration-and-citizenship", text: "Immigration and Citizenship" },
  { value: "indigenous-affairs", text: "Indigenous Affairs" },
  { value: "innovation-and-entrepreneurship", text: "Innovation and Entrepreneurship" },
  { value: "innovation-and-technology", text: "Innovation and Technology" },
  { value: "insurance", text: "Insurance" },
  { value: "interior-and-home-affairs", text: "Interior and Home Affairs" },
  { value: "interior-design-and-architecture", text: "Interior Design and Architecture" },
  { value: "internal-security", text: "Internal Security" },
  { value: "intellectual-property-and-patents", text: "Intellectual Property and Patents" },
  { value: "infrastructure-and-transportation", text: "Infrastructure and Transportation" },
  { value: "infrastructure-development", text: "Infrastructure Development" },
  { value: "justice", text: "Justice" },
  { value: "labor-and-employment", text: "Labor and Employment" },
  { value: "legal-and-compliance", text: "Legal and Compliance" },
  { value: "luxury-goods", text: "Luxury Goods" },
  { value: "manufacturing", text: "Manufacturing" },
  { value: "maritime", text: "Maritime" },
  { value: "media-and-entertainment", text: "Media and Entertainment" },
  { value: "minority-affairs", text: "Minority Affairs" },
  { value: "non-profit-and-charitable-organizations", text: "Non-Profit and Charitable Organizations" },
  { value: "pet-care-and-veterinary-services", text: "Pet Care and Veterinary Services" },
  { value: "postal-services-and-telecommunications", text: "Postal Services and Telecommunications" },
  { value: "professional-services", text: "Professional Services" },
  { value: "public-administration-and-governance", text: "Public Administration and Governance" },
  { value: "public-relations-and-communications", text: "Public Relations and Communications" },
  { value: "public-works", text: "Public Works" },
  { value: "publishing-and-printing", text: "Publishing and Printing" },
  { value: "real-estate", text: "Real Estate" },
  { value: "refugees-and-migration", text: "Refugees and Migration" },
  { value: "renewable-resources", text: "Renewable Resources" },
  { value: "retail-and-consumer-goods", text: "Retail and Consumer Goods" },
  { value: "science-and-innovation", text: "Science and Innovation" },
  { value: "science-and-technology", text: "Science and Technology" },
  { value: "senior-citizens", text: "Senior Citizens" },
  { value: "small-and-medium-enterprises-smes", text: "Small and Medium Enterprises (SMEs)" },
  { value: "social-media-and-digital-marketing", text: "Social Media and Digital Marketing" },
  { value: "social-welfare", text: "Social Welfare" },
  { value: "sports-and-culture", text: "Sports and Culture" },
  { value: "sports-and-recreation", text: "Sports and Recreation" },
  { value: "supply-chain-and-procurement", text: "Supply Chain and Procurement" },
  { value: "taxation-and-revenue", text: "Taxation and Revenue" },
  { value: "technology-and-telecommunications", text: "Technology and Telecommunications" },
  { value: "telecommunication-and-digital-infrastructure", text: "Telecommunication and Digital Infrastructure" },
  { value: "television-and-radio-broadcasting", text: "Television and Radio Broadcasting" },
  { value: "tobacco-and-cannabis", text: "Tobacco and Cannabis" },
  { value: "tourism", text: "Tourism" },
  { value: "trade-and-export-development", text: "Trade and Export Development" },
  { value: "trade-unions-and-labor-relations", text: "Trade Unions and Labor Relations" },
  { value: "transportation-and-logistics", text: "Transportation and Logistics" },
  { value: "transportation-safety-and-regulation", text: "Transportation Safety and Regulation" },
  { value: "veterans-affairs", text: "Veterans Affairs" },
  { value: "waste-management-and-recycling", text: "Waste Management and Recycling" },
  { value: "water-and-sanitation", text: "Water and Sanitation" },
  { value: "womens-affairs", text: "Women’s Affairs" },
  { value: "youth-affairs-and-sports", text: "Youth Affairs and Sports" },
  { value: "youth-and-family-affairs", text: "Youth and Family Affairs" },
];

export const PRACTICES_OPTIONS = [
  {
    category: "agriculture-and-rural-development",
    text: "Agricultural Law",
    value: "agricultural-law",
  },
  {
    category: "agriculture-and-rural-development",
    text: "Land Use and Zoning",
    value: "land-use-and-zoning",
  },
  {
    category: "agriculture-and-rural-development",
    text: "Environmental Law",
    value: "environmental-law",
  },
  {
    category: "agriculture-and-rural-development",
    text: "Food Safety Law",
    value: "food-safety-law",
  },
  {
    category: "commerce-and-industry",
    text: "Commercial Law",
    value: "commercial-law",
  },
  {
    category: "commerce-and-industry",
    text: "Trade Law",
    value: "trade-law",
  },
  {
    category: "commerce-and-industry",
    text: "Corporate Law",
    value: "corporate-law",
  },
  {
    category: "commerce-and-industry",
    text: "Consumer Protection Law",
    value: "consumer-protection-law",
  },
  {
    category: "communications-and-information-technology",
    text: "Telecommunications Law",
    value: "telecommunications-law",
  },
  {
    category: "communications-and-information-technology",
    text: "Cybersecurity Law",
    value: "cybersecurity-law",
  },
  {
    category: "communications-and-information-technology",
    text: "Privacy Law",
    value: "privacy-law",
  },
  {
    category: "communications-and-information-technology",
    text: "Intellectual Property Law",
    value: "intellectual-property-law",
  },
  {
    category: "defense-and-military",
    text: "National Security Law",
    value: "national-security-law",
  },
  {
    category: "defense-and-military",
    text: "Military Law",
    value: "military-law",
  },
  {
    category: "defense-and-military",
    text: "Defense Procurement Law",
    value: "defense-procurement-law",
  },
  {
    category: "defense-and-military",
    text: "Veterans’ Law",
    value: "veterans-law",
  },
  {
    category: "education",
    text: "Education Law",
    value: "education-law",
  },
  {
    category: "education",
    text: "Administrative Law",
    value: "administrative-law",
  },
  {
    category: "education",
    text: "Employment Law",
    value: "employment-law",
  },
  {
    category: "education",
    text: "Disability Law",
    value: "disability-law",
  },
  {
    category: "energy",
    text: "Energy Law",
    value: "energy-law",
  },
  {
    category: "energy",
    text: "Environmental Law",
    value: "environmental-law",
  },
  {
    category: "energy",
    text: "Regulatory Law",
    value: "regulatory-law",
  },
  {
    category: "energy",
    text: "Renewable Energy Law",
    value: "renewable-energy-law",
  },
  {
    category: "environment-and-natural-resources",
    text: "Environmental Law",
    value: "environmental-law",
  },
  {
    category: "environment-and-natural-resources",
    text: "Natural Resources Law",
    value: "natural-resources-law",
  },
  {
    category: "environment-and-natural-resources",
    text: "Climate Change Law",
    value: "climate-change-law",
  },
  {
    category: "environment-and-natural-resources",
    text: "Wildlife Law",
    value: "wildlife-law",
  },
  {
    category: "finance-and-treasury",
    text: "Financial Services Law",
    value: "financial-services-law",
  },
  {
    category: "finance-and-treasury",
    text: "Tax Law",
    value: "tax-law",
  },
  {
    category: "finance-and-treasury",
    text: "Public Finance Law",
    value: "public-finance-law",
  },
  {
    category: "finance-and-treasury",
    text: "Securities Law",
    value: "securities-law",
  },
  {
    category: "foreign-affairs",
    text: "International Law",
    value: "international-law",
  },
  {
    category: "foreign-affairs",
    text: "Diplomatic Law",
    value: "diplomatic-law",
  },
  {
    category: "foreign-affairs",
    text: "Trade Law",
    value: "trade-law",
  },
  {
    category: "foreign-affairs",
    text: "Human Rights Law",
    value: "human-rights-law",
  },
  {
    category: "health-and-human-services",
    text: "Health Law",
    value: "health-law",
  },
  {
    category: "health-and-human-services",
    text: "Administrative Law",
    value: "administrative-law",
  },
  {
    category: "health-and-human-services",
    text: "Public Health Law",
    value: "public-health-law",
  },
  {
    category: "health-and-human-services",
    text: "Insurance Law",
    value: "insurance-law",
  },
  {
    category: "housing-and-urban-development",
    text: "Real Estate Law",
    value: "real-estate-law",
  },
  {
    category: "housing-and-urban-development",
    text: "Land Use and Zoning Law",
    value: "land-use-and-zoning-law",
  },
  {
    category: "housing-and-urban-development",
    text: "Housing Law",
    value: "housing-law",
  },
  {
    category: "housing-and-urban-development",
    text: "Urban Planning Law",
    value: "urban-planning-law",
  },
  {
    category: "immigration-and-citizenship",
    text: "Immigration Law",
    value: "immigration-law",
  },
  {
    category: "immigration-and-citizenship",
    text: "Refugee Law",
    value: "refugee-law",
  },
  {
    category: "immigration-and-citizenship",
    text: "Nationality Law",
    value: "nationality-law",
  },
  {
    category: "immigration-and-citizenship",
    text: "Asylum Law",
    value: "asylum-law",
  },
  {
    category: "infrastructure-and-transportation",
    text: "Transportation Law",
    value: "transportation-law",
  },
  {
    category: "infrastructure-and-transportation",
    text: "Infrastructure Law",
    value: "infrastructure-law",
  },
  {
    category: "infrastructure-and-transportation",
    text: "Public-Private Partnership Law",
    value: "public-private-partnership-law",
  },
  {
    category: "infrastructure-and-transportation",
    text: "Construction Law",
    value: "construction-law",
  },
  {
    category: "interior-and-home-affairs",
    text: "Administrative Law",
    value: "administrative-law",
  },
  {
    category: "interior-and-home-affairs",
    text: "Constitutional Law",
    value: "constitutional-law",
  },
  {
    category: "interior-and-home-affairs",
    text: "Civil Rights Law",
    value: "civil-rights-law",
  },
  {
    category: "interior-and-home-affairs",
    text: "Public Safety Law",
    value: "public-safety-law",
  },
  {
    category: "justice",
    text: "Criminal Law",
    value: "criminal-law",
  },
  {
    category: "justice",
    text: "Civil Rights Law",
    value: "civil-rights-law",
  },
  {
    category: "justice",
    text: "Judicial Administration Law",
    value: "judicial-administration-law",
  },
  {
    category: "justice",
    text: "Correctional Law",
    value: "correctional-law",
  },
  {
    category: "labor-and-employment",
    text: "Employment Law",
    value: "employment-law",
  },
  {
    category: "labor-and-employment",
    text: "Labor Law",
    value: "labor-law",
  },
  {
    category: "labor-and-employment",
    text: "Occupational Health and Safety Law",
    value: "occupational-health-and-safety-law",
  },
  {
    category: "labor-and-employment",
    text: "Discrimination Law",
    value: "discrimination-law",
  },
  {
    category: "public-administration-and-governance",
    text: "Administrative Law",
    value: "administrative-law",
  },
  {
    category: "public-administration-and-governance",
    text: "Public Policy Law",
    value: "public-policy-law",
  },
  {
    category: "public-administration-and-governance",
    text: "Government Contracts Law",
    value: "government-contracts-law",
  },
  {
    category: "public-administration-and-governance",
    text: "Transparency and Accountability Law",
    value: "transparency-and-accountability-law",
  },
  {
    category: "science-and-technology",
    text: "Science Policy Law",
    value: "science-policy-law",
  },
  {
    category: "science-and-technology",
    text: "Technology Law",
    value: "technology-law",
  },
  {
    category: "science-and-technology",
    text: "Intellectual Property Law",
    value: "intellectual-property-law",
  },
  {
    category: "science-and-technology",
    text: "Research and Development Law",
    value: "research-and-development-law",
  },
  {
    category: "social-welfare",
    text: "Social Security Law",
    value: "social-security-law",
  },
  {
    category: "social-welfare",
    text: "Welfare Law",
    value: "welfare-law",
  },
  {
    category: "social-welfare",
    text: "Disability Law",
    value: "disability-law",
  },
  {
    category: "social-welfare",
    text: "Family Law",
    value: "family-law",
  },
  {
    category: "sports-and-culture",
    text: "Sports Law",
    value: "sports-law",
  },
  {
    category: "sports-and-culture",
    text: "Entertainment Law",
    value: "entertainment-law",
  },
  {
    category: "sports-and-culture",
    text: "Cultural Heritage Law",
    value: "cultural-heritage-law",
  },
  {
    category: "sports-and-culture",
    text: "Recreation Law",
    value: "recreation-law",
  },
  {
    category: "tourism",
    text: "Tourism Law",
    value: "tourism-law",
  },
  {
    category: "tourism",
    text: "Hospitality Law",
    value: "hospitality-law",
  },
  {
    category: "tourism",
    text: "Travel Law",
    value: "travel-law",
  },
  {
    category: "tourism",
    text: "Cultural Property Law",
    value: "cultural-property-law",
  },
  {
    category: "trade-and-export-development",
    text: "Trade Law",
    value: "trade-law",
  },
  {
    category: "trade-and-export-development",
    text: "Export Control Law",
    value: "export-control-law",
  },
  {
    category: "trade-and-export-development",
    text: "International Trade Compliance Law",
    value: "international-trade-compliance-law",
  },
  {
    category: "trade-and-export-development",
    text: "Market Access Law",
    value: "market-access-law",
  },
  {
    category: "water-and-sanitation",
    text: "Water Law",
    value: "water-law",
  },
  {
    category: "water-and-sanitation",
    text: "Environmental Law",
    value: "environmental-law",
  },
  {
    category: "water-and-sanitation",
    text: "Public Health Law",
    value: "public-health-law",
  },
  {
    category: "water-and-sanitation",
    text: "Sanitation Law",
    value: "sanitation-law",
  },
  {
    category: "youth-and-family-affairs",
    text: "Family Law",
    value: "family-law",
  },
  {
    category: "youth-and-family-affairs",
    text: "Child Protection Law",
    value: "child-protection-law",
  },
  {
    category: "youth-and-family-affairs",
    text: "Youth Justice Law",
    value: "youth-justice-law",
  },
  {
    category: "youth-and-family-affairs",
    text: "Gender Equality Law",
    value: "gender-equality-law",
  },
  {
    category: "cultural-affairs",
    text: "Cultural Property Law",
    value: "cultural-property-law",
  },
  {
    category: "cultural-affairs",
    text: "Arts Law",
    value: "arts-law",
  },
  {
    category: "cultural-affairs",
    text: "Heritage Preservation Law",
    value: "heritage-preservation-law",
  },
  {
    category: "cultural-affairs",
    text: "Cultural Diplomacy Law",
    value: "cultural-diplomacy-law",
  },
  {
    category: "fisheries-and-oceans",
    text: "Maritime Law",
    value: "maritime-law",
  },
  {
    category: "fisheries-and-oceans",
    text: "Fisheries Law",
    value: "fisheries-law",
  },
  {
    category: "fisheries-and-oceans",
    text: "Environmental Law",
    value: "environmental-law",
  },
  {
    category: "fisheries-and-oceans",
    text: "Marine Conservation Law",
    value: "marine-conservation-law",
  },
  {
    category: "indigenous-affairs",
    text: "Indigenous Rights Law",
    value: "indigenous-rights-law",
  },
  {
    category: "indigenous-affairs",
    text: "Land Claims Law",
    value: "land-claims-law",
  },
  {
    category: "indigenous-affairs",
    text: "Cultural Preservation Law",
    value: "cultural-preservation-law",
  },
  {
    category: "indigenous-affairs",
    text: "Economic Development Law",
    value: "economic-development-law",
  },
  {
    category: "innovation-and-entrepreneurship",
    text: "Innovation Law",
    value: "innovation-law",
  },
  {
    category: "innovation-and-entrepreneurship",
    text: "Intellectual Property Law",
    value: "intellectual-property-law",
  },
  {
    category: "innovation-and-entrepreneurship",
    text: "Startup Law",
    value: "startup-law",
  },
  {
    category: "innovation-and-entrepreneurship",
    text: "Business Incubation Law",
    value: "business-incubation-law",
  },
  {
    category: "internal-security",
    text: "Counter-Terrorism Law",
    value: "counter-terrorism-law",
  },
  {
    category: "internal-security",
    text: "Intelligence Law",
    value: "intelligence-law",
  },
  {
    category: "internal-security",
    text: "National Security Law",
    value: "national-security-law",
  },
  {
    category: "internal-security",
    text: "Emergency Response Law",
    value: "emergency-response-law",
  },
  {
    category: "minority-affairs",
    text: "Anti-Discrimination Law",
    value: "anti-discrimination-law",
  },
  {
    category: "minority-affairs",
    text: "Civil Rights Law",
    value: "civil-rights-law",
  },
  {
    category: "minority-affairs",
    text: "Minority Business Law",
    value: "minority-business-law",
  },
  {
    category: "minority-affairs",
    text: "Cultural Integration Law",
    value: "cultural-integration-law",
  },
  {
    category: "postal-services-and-telecommunications",
    text: "Postal Law",
    value: "postal-law",
  },
  {
    category: "postal-services-and-telecommunications",
    text: "Telecommunications Law",
    value: "telecommunications-law",
  },
  {
    category: "postal-services-and-telecommunications",
    text: "Broadcasting Law",
    value: "broadcasting-law",
  },
  {
    category: "postal-services-and-telecommunications",
    text: "Universal Service Law",
    value: "universal-service-law",
  },
  {
    category: "public-works",
    text: "Construction Law",
    value: "construction-law",
  },
  {
    category: "public-works",
    text: "Government Contracts Law",
    value: "government-contracts-law",
  },
  {
    category: "public-works",
    text: "Public Utilities Law",
    value: "public-utilities-law",
  },
  {
    category: "public-works",
    text: "Infrastructure Law",
    value: "infrastructure-law",
  },
  {
    category: "science-and-innovation",
    text: "Research and Development Law",
    value: "research-and-development-law",
  },
  {
    category: "science-and-innovation",
    text: "Intellectual Property Law",
    value: "intellectual-property-law",
  },
  {
    category: "science-and-innovation",
    text: "Innovation Policy Law",
    value: "innovation-policy-law",
  },
  {
    category: "science-and-innovation",
    text: "Technology Transfer Law",
    value: "technology-transfer-law",
  },
  {
    category: "senior-citizens",
    text: "Elder Law",
    value: "elder-law",
  },
  {
    category: "senior-citizens",
    text: "Pension Law",
    value: "pension-law",
  },
  {
    category: "senior-citizens",
    text: "Healthcare Law",
    value: "healthcare-law",
  },
  {
    category: "senior-citizens",
    text: "Social Services Law",
    value: "social-services-law",
  },
  {
    category: "small-and-medium-enterprises-smes",
    text: "SME Law",
    value: "sme-law",
  },
  {
    category: "small-and-medium-enterprises-smes",
    text: "Commercial Law",
    value: "commercial-law",
  },
  {
    category: "small-and-medium-enterprises-smes",
    text: "Business Development Law",
    value: "business-development-law",
  },
  {
    category: "small-and-medium-enterprises-smes",
    text: "Financing Law",
    value: "financing-law",
  },
  {
    category: "telecommunication-and-digital-infrastructure",
    text: "Telecommunications Law",
    value: "telecommunications-law",
  },
  {
    category: "telecommunication-and-digital-infrastructure",
    text: "Digital Infrastructure Law",
    value: "digital-infrastructure-law",
  },
  {
    category: "telecommunication-and-digital-infrastructure",
    text: "Cybersecurity Law",
    value: "cybersecurity-law",
  },
  {
    category: "telecommunication-and-digital-infrastructure",
    text: "Internet Governance Law",
    value: "internet-governance-law",
  },
  {
    category: "trade-unions-and-labor-relations",
    text: "Labor Law",
    value: "labor-law",
  },
  {
    category: "trade-unions-and-labor-relations",
    text: "Collective Bargaining Law",
    value: "collective-bargaining-law",
  },
  {
    category: "trade-unions-and-labor-relations",
    text: "Industrial Relations Law",
    value: "industrial-relations-law",
  },
  {
    category: "trade-unions-and-labor-relations",
    text: "Dispute Resolution Law",
    value: "dispute-resolution-law",
  },
  {
    category: "veterans-affairs",
    text: "Veterans’ Law",
    value: "veterans-law",
  },
  {
    category: "veterans-affairs",
    text: "Military Benefits Law",
    value: "military-benefits-law",
  },
  {
    category: "veterans-affairs",
    text: "Healthcare Law",
    value: "healthcare-law",
  },
  {
    category: "veterans-affairs",
    text: "Employment Law",
    value: "employment-law",
  },
  {
    category: "womens-affairs",
    text: "Gender Equality Law",
    value: "gender-equality-law",
  },
  {
    category: "womens-affairs",
    text: "Women’s Rights Law",
    value: "womens-rights-law",
  },
  {
    category: "womens-affairs",
    text: "Anti-Violence Law",
    value: "anti-violence-law",
  },
  {
    category: "womens-affairs",
    text: "Economic Empowerment Law",
    value: "economic-empowerment-law",
  },
  {
    category: "youth-affairs-and-sports",
    text: "Youth Law",
    value: "youth-law",
  },
  {
    category: "youth-affairs-and-sports",
    text: "Sports Law",
    value: "sports-law",
  },
  {
    category: "youth-affairs-and-sports",
    text: "Recreational Law",
    value: "recreational-law",
  },
  {
    category: "youth-affairs-and-sports",
    text: "Anti-Doping Law",
    value: "anti-doping-law",
  },
  {
    category: "disaster-management-and-relief",
    text: "Disaster Response Law",
    value: "disaster-response-law",
  },
  {
    category: "disaster-management-and-relief",
    text: "Emergency Management Law",
    value: "emergency-management-law",
  },
  {
    category: "disaster-management-and-relief",
    text: "Humanitarian Aid Law",
    value: "humanitarian-aid-law",
  },
  {
    category: "disaster-management-and-relief",
    text: "Recovery Law",
    value: "recovery-law",
  },
  {
    category: "human-rights",
    text: "Human Rights Law",
    value: "human-rights-law",
  },
  {
    category: "human-rights",
    text: "Civil Liberties Law",
    value: "civil-liberties-law",
  },
  {
    category: "human-rights",
    text: "International Human Rights Law",
    value: "international-human-rights-law",
  },
  {
    category: "human-rights",
    text: "Anti-Torture Law",
    value: "anti-torture-law",
  },
  {
    category: "refugees-and-migration",
    text: "Refugee Law",
    value: "refugee-law",
  },
  {
    category: "refugees-and-migration",
    text: "Immigration Law",
    value: "immigration-law",
  },
  {
    category: "refugees-and-migration",
    text: "Border Control Law",
    value: "border-control-law",
  },
  {
    category: "refugees-and-migration",
    text: "Integration Law",
    value: "integration-law",
  },
  {
    category: "data-protection-and-privacy",
    text: "Data Protection Law",
    value: "data-protection-law",
  },
  {
    category: "data-protection-and-privacy",
    text: "Privacy Law",
    value: "privacy-law",
  },
  {
    category: "data-protection-and-privacy",
    text: "Cybersecurity Law",
    value: "cybersecurity-law",
  },
  {
    category: "data-protection-and-privacy",
    text: "Information Security Law",
    value: "information-security-law",
  },
  {
    category: "climate-change-and-sustainability",
    text: "Climate Change Law",
    value: "climate-change-law",
  },
  {
    category: "climate-change-and-sustainability",
    text: "Environmental Law",
    value: "environmental-law",
  },
  {
    category: "climate-change-and-sustainability",
    text: "Renewable Energy Law",
    value: "renewable-energy-law",
  },
  {
    category: "climate-change-and-sustainability",
    text: "Sustainability Law",
    value: "sustainability-law",
  },
  {
    category: "renewable-resources",
    text: "Renewable Energy Law",
    value: "renewable-energy-law",
  },
  {
    category: "renewable-resources",
    text: "Environmental Law",
    value: "environmental-law",
  },
  {
    category: "renewable-resources",
    text: "Resource Management Law",
    value: "resource-management-law",
  },
  {
    category: "renewable-resources",
    text: "Sustainability Law",
    value: "sustainability-law",
  },
  {
    category: "animal-welfare",
    text: "Animal Law",
    value: "animal-law",
  },
  {
    category: "animal-welfare",
    text: "Wildlife Conservation Law",
    value: "wildlife-conservation-law",
  },
  {
    category: "animal-welfare",
    text: "Veterinary Law",
    value: "veterinary-law",
  },
  {
    category: "animal-welfare",
    text: "Anti-Cruelty Law",
    value: "anti-cruelty-law",
  },
  {
    category: "taxation-and-revenue",
    text: "Tax Law",
    value: "tax-law",
  },
  {
    category: "taxation-and-revenue",
    text: "Revenue Law",
    value: "revenue-law",
  },
  {
    category: "taxation-and-revenue",
    text: "Public Finance Law",
    value: "public-finance-law",
  },
  {
    category: "taxation-and-revenue",
    text: "Fiscal Policy Law",
    value: "fiscal-policy-law",
  },
  {
    category: "infrastructure-development",
    text: "Construction Law",
    value: "construction-law",
  },
  {
    category: "infrastructure-development",
    text: "Infrastructure Law",
    value: "infrastructure-law",
  },
  {
    category: "infrastructure-development",
    text: "Public-Private Partnership Law",
    value: "public-private-partnership-law",
  },
  {
    category: "infrastructure-development",
    text: "Urban Planning Law",
    value: "urban-planning-law",
  },
  {
    category: "civil-service",
    text: "Administrative Law",
    value: "administrative-law",
  },
  {
    category: "civil-service",
    text: "Public Employment Law",
    value: "public-employment-law",
  },
  {
    category: "civil-service",
    text: "Government Contracts Law",
    value: "government-contracts-law",
  },
  {
    category: "civil-service",
    text: "Public Sector Reform Law",
    value: "public-sector-reform-law",
  },
  {
    category: "transportation-safety-and-regulation",
    text: "Transportation Law",
    value: "transportation-law",
  },
  {
    category: "transportation-safety-and-regulation",
    text: "Aviation Law",
    value: "aviation-law",
  },
  {
    category: "transportation-safety-and-regulation",
    text: "Maritime Law",
    value: "maritime-law",
  },
  {
    category: "transportation-safety-and-regulation",
    text: "Rail Safety Law",
    value: "rail-safety-law",
  },
  {
    category: "consumer-affairs",
    text: "Consumer Protection Law",
    value: "consumer-protection-law",
  },
  {
    category: "consumer-affairs",
    text: "Product Safety Law",
    value: "product-safety-law",
  },
  {
    category: "consumer-affairs",
    text: "Fair Trading Law",
    value: "fair-trading-law",
  },
  {
    category: "consumer-affairs",
    text: "Advertising Law",
    value: "advertising-law",
  },
  {
    category: "innovation-and-technology",
    text: "Technology Law",
    value: "technology-law",
  },
  {
    category: "innovation-and-technology",
    text: "Innovation Law",
    value: "innovation-law",
  },
  {
    category: "innovation-and-technology",
    text: "Intellectual Property Law",
    value: "intellectual-property-law",
  },
  {
    category: "innovation-and-technology",
    text: "Digital Transformation Law",
    value: "digital-transformation-law",
  },
  {
    category: "banking-and-finance",
    text: "Financial institutions",
    value: "financial-institutions",
  },
  {
    category: "banking-and-finance",
    text: "Investment banks",
    value: "investment-banks",
  },
  {
    category: "banking-and-finance",
    text: "Private equity firms",
    value: "private-equity-firms",
  },
  {
    category: "banking-and-finance",
    text: "Hedge funds",
    value: "hedge-funds",
  },
  {
    category: "healthcare",
    text: "Hospitals",
    value: "hospitals",
  },
  {
    category: "healthcare",
    text: "Pharmaceutical companies",
    value: "pharmaceutical-companies",
  },
  {
    category: "healthcare",
    text: "Medical device manufacturers",
    value: "medical-device-manufacturers",
  },
  {
    category: "healthcare",
    text: "Health insurance companies",
    value: "health-insurance-companies",
  },
  {
    category: "real-estate",
    text: "Commercial real estate developers",
    value: "commercial-real-estate-developers",
  },
  {
    category: "real-estate",
    text: "Property management companies",
    value: "property-management-companies",
  },
  {
    category: "real-estate",
    text: "Real estate investment trusts (REITs)",
    value: "real-estate-investment-trusts-reits",
  },
  {
    category: "real-estate",
    text: "Construction firms",
    value: "construction-firms",
  },
  {
    category: "technology-and-telecommunications",
    text: "Software and hardware companies",
    value: "software-and-hardware-companies",
  },
  {
    category: "technology-and-telecommunications",
    text: "Telecommunications providers",
    value: "telecommunications-providers",
  },
  {
    category: "technology-and-telecommunications",
    text: "Internet service providers",
    value: "internet-service-providers",
  },
  {
    category: "technology-and-telecommunications",
    text: "Tech startups",
    value: "tech-startups",
  },
  {
    category: "energy-and-utilities",
    text: "Oil and gas companies",
    value: "oil-and-gas-companies",
  },
  {
    category: "energy-and-utilities",
    text: "Renewable energy companies",
    value: "renewable-energy-companies",
  },
  {
    category: "energy-and-utilities",
    text: "Utility providers",
    value: "utility-providers",
  },
  {
    category: "energy-and-utilities",
    text: "Mining companies",
    value: "mining-companies",
  },
  {
    category: "manufacturing",
    text: "Automotive manufacturers",
    value: "automotive-manufacturers",
  },
  {
    category: "manufacturing",
    text: "Electronics manufacturers",
    value: "electronics-manufacturers",
  },
  {
    category: "manufacturing",
    text: "Industrial equipment manufacturers",
    value: "industrial-equipment-manufacturers",
  },
  {
    category: "manufacturing",
    text: "Consumer goods manufacturers",
    value: "consumer-goods-manufacturers",
  },
  {
    category: "retail-and-consumer-goods",
    text: "Retail chains",
    value: "retail-chains",
  },
  {
    category: "retail-and-consumer-goods",
    text: "E-commerce businesses",
    value: "e-commerce-businesses",
  },
  {
    category: "retail-and-consumer-goods",
    text: "Food and beverage companies",
    value: "food-and-beverage-companies",
  },
  {
    category: "retail-and-consumer-goods",
    text: "Apparel companies",
    value: "apparel-companies",
  },
  {
    category: "media-and-entertainment",
    text: "Film and television studios",
    value: "film-and-television-studios",
  },
  {
    category: "media-and-entertainment",
    text: "Music industry entities",
    value: "music-industry-entities",
  },
  {
    category: "media-and-entertainment",
    text: "Publishing companies",
    value: "publishing-companies",
  },
  {
    category: "media-and-entertainment",
    text: "Sports organizations",
    value: "sports-organizations",
  },
  {
    category: "transportation-and-logistics",
    text: "Airlines",
    value: "airlines",
  },
  {
    category: "transportation-and-logistics",
    text: "Shipping companies",
    value: "shipping-companies",
  },
  {
    category: "transportation-and-logistics",
    text: "Logistics and supply chain management firms",
    value: "logistics-and-supply-chain-management-firms",
  },
  {
    category: "transportation-and-logistics",
    text: "Rail and trucking companies",
    value: "rail-and-trucking-companies",
  },
  {
    category: "government-and-public-sector",
    text: "Government agencies",
    value: "government-agencies",
  },
  {
    category: "government-and-public-sector",
    text: "Municipalities",
    value: "municipalities",
  },
  {
    category: "government-and-public-sector",
    text: "Educational institutions",
    value: "educational-institutions",
  },
  {
    category: "government-and-public-sector",
    text: "Non-profit organizations",
    value: "non-profit-organizations",
  },
  {
    category: "insurance",
    text: "Life and health insurance providers",
    value: "life-and-health-insurance-providers",
  },
  {
    category: "insurance",
    text: "Property and casualty insurance companies",
    value: "property-and-casualty-insurance-companies",
  },
  {
    category: "insurance",
    text: "Reinsurance firms",
    value: "reinsurance-firms",
  },
  {
    category: "insurance",
    text: "Insurance brokers",
    value: "insurance-brokers",
  },
  {
    category: "hospitality-and-leisure",
    text: "Hotels and resorts",
    value: "hotels-and-resorts",
  },
  {
    category: "hospitality-and-leisure",
    text: "Travel agencies",
    value: "travel-agencies",
  },
  {
    category: "hospitality-and-leisure",
    text: "Restaurant chains",
    value: "restaurant-chains",
  },
  {
    category: "hospitality-and-leisure",
    text: "Casinos and gaming companies",
    value: "casinos-and-gaming-companies",
  },
  {
    category: "agriculture-and-food-production",
    text: "Agribusiness companies",
    value: "agribusiness-companies",
  },
  {
    category: "agriculture-and-food-production",
    text: "Food processing companies",
    value: "food-processing-companies",
  },
  {
    category: "agriculture-and-food-production",
    text: "Agricultural cooperatives",
    value: "agricultural-cooperatives",
  },
  {
    category: "agriculture-and-food-production",
    text: "Farm equipment manufacturers",
    value: "farm-equipment-manufacturers",
  },
  {
    category: "aerospace-and-defense",
    text: "Aircraft manufacturers",
    value: "aircraft-manufacturers",
  },
  {
    category: "aerospace-and-defense",
    text: "Defense contractors",
    value: "defense-contractors",
  },
  {
    category: "aerospace-and-defense",
    text: "Space exploration companies",
    value: "space-exploration-companies",
  },
  {
    category: "aerospace-and-defense",
    text: "Military technology firms",
    value: "military-technology-firms",
  },
  {
    category: "biotechnology-and-life-sciences",
    text: "Biotech startups",
    value: "biotech-startups",
  },
  {
    category: "biotechnology-and-life-sciences",
    text: "Research institutions",
    value: "research-institutions",
  },
  {
    category: "biotechnology-and-life-sciences",
    text: "Clinical research organizations",
    value: "clinical-research-organizations",
  },
  {
    category: "biotechnology-and-life-sciences",
    text: "Medical laboratories",
    value: "medical-laboratories",
  },
  {
    category: "education",
    text: "Universities and colleges",
    value: "universities-and-colleges",
  },
  {
    category: "education",
    text: "Private and public schools",
    value: "private-and-public-schools",
  },
  {
    category: "education",
    text: "Educational technology firms",
    value: "educational-technology-firms",
  },
  {
    category: "education",
    text: "Online learning platforms",
    value: "online-learning-platforms",
  },
  {
    category: "professional-services",
    text: "Accounting firms",
    value: "accounting-firms",
  },
  {
    category: "professional-services",
    text: "Consulting firms",
    value: "consulting-firms",
  },
  {
    category: "professional-services",
    text: "Marketing and advertising agencies",
    value: "marketing-and-advertising-agencies",
  },
  {
    category: "professional-services",
    text: "Human resources firms",
    value: "human-resources-firms",
  },
  {
    category: "environmental",
    text: "Environmental consulting firms",
    value: "environmental-consulting-firms",
  },
  {
    category: "environmental",
    text: "Waste management companies",
    value: "waste-management-companies",
  },
  {
    category: "environmental",
    text: "Conservation organizations",
    value: "conservation-organizations",
  },
  {
    category: "environmental",
    text: "Renewable resource firms",
    value: "renewable-resource-firms",
  },
];
